module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rounded-b relative",
    class: [_vm.teacher_tap_in ? 'h-72 border border-solid border-gray-200 w-96 flex items-center justify-center -mt-16' : 'bg-gray-100 h-56']
  }, [_c('div', {
    staticClass: "absolute left-0 bottom-0 top-0 right-0 z-20 w-full h-full"
  }, [_c('div', {
    staticClass: "relative w-full h-full"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2 h-full"
  }, [_c('div', {
    staticClass: "font-poppins text-xs w-full py-0.5 text-white text-center",
    class: {
      'bg-gray-300 bg-opacity-50 backdrop-blur-lg': _vm.cameraOn,
      'bg-gray-800 bg-opacity-50  backdrop-blur-lg': !_vm.cameraOn || _vm.teacher_tap_in
    }
  }, [_vm._v("\n          Teacher\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center px-2"
  }, [(_vm.teacher_tap_in) ? _c('div', {
    staticClass: "rounded-tr-full bg-blue-700 text-base rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text-white text-xs font-poppins font-medium"
  }, [_vm._v("Teacher Tap In")])]) : _c('div'), _vm._v(" "), (_vm.teacher_speaking[_vm.author_id]) ? _c('div', [_c('VolumeIndicator')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex px-2 flex-grow h-full w-full",
    on: {
      "mouseover": function($event) {
        _vm.isToSeeSettings = true
      },
      "mouseleave": function($event) {
        _vm.isToSeeSettings = false
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center w-full"
  }, [(_vm.video_audio_is_active && _vm.joinedAudioDiscussion && _vm.is_my_teacher && _vm.cameraOn && _vm.isToSeeSettings) ? _c('button', {
    staticClass: "flex justify-center text-center items-center bg-gray-500 bg-opacity-50 h-10 w-10 rounded-full",
    on: {
      "click": function($event) {
        return _vm.openDeviceSettings()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-gear text-white text-center text-lg"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between pb-2 px-2"
  }, [_c('div', {
    staticClass: "flex space-x-1.5 bg-gray-800 bg-opacity-50 rounded-full px-3 py-1.5 h-7 items-center"
  }, [_c('div', {
    staticClass: "truncate text-white max-width-name text-xs"
  }, [_c('span', [_vm._v(_vm._s(_vm.author_name))]), _vm._v(" "), (_vm.is_my_teacher) ? _c('span', {
    staticClass: "text-pinky ml-0.5"
  }, [_vm._v("(Me)")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "top": "calc(50% - 40px)",
      "left": "calc(50% - 40px)"
    }
  }, [_c('img', {
    staticClass: "rounded-full object-cover",
    style: ({
      width: _vm.teacher_tap_in ? '90px' : '70px',
      height: _vm.teacher_tap_in ? '90px' : '70px',
    }),
    attrs: {
      "src": _vm.avatar_url
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa-solid fa-chalkboard-user text-white"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6ac01b44!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/LDDiscussionTeacherCircle.vue
// module id = 1773
// module chunks = 61